import { Grid2 } from '@mui/material';
import React from 'react';

import { ResourceDetailItemContainer } from '@/shared/components/ui/resource-detail/content/resource-detail-content.styled';
import { TResourceDetailContent } from '@/shared/components/ui/resource-detail/content/resource-detail-content.types';
import { useResourceDetailContext } from '@/shared/components/ui/resource-detail/context/resource-detail-context';
import { ResourceDetailItem } from '@/shared/components/ui/resource-detail/item/resource-detail-item';
import { COMPACT_ITEMS_PER_ROW } from '@/shared/components/ui/resource-detail/resource-detail.constants';
import {
  getCompactColumns,
  getCompactItems,
  getFullItems,
  getResourceDetailItemSize,
} from '@/shared/components/ui/resource-detail/resource-detail.utils';

export const ResourceDetailContent: React.FC<TResourceDetailContent> = ({
  items,
  itemsPerRow = 4,
  compactItemsPerRow = COMPACT_ITEMS_PER_ROW,
}) => {
  const { isCompact } = useResourceDetailContext();

  const visibleItems = isCompact ? getCompactItems(items) : getFullItems(items);

  const compactColumns = getCompactColumns(items);

  if (isCompact && compactColumns > compactItemsPerRow) {
    throw new Error(
      `Compact mode fits at most ${compactItemsPerRow} columns; received ${compactColumns}. Use showOnlyOn: 'full' or smaller colSpans to trim the compact view.`,
    );
  }

  // Compact sizes the grid to the columns actually used so the row fills.
  const containerColumns = isCompact ? compactColumns : itemsPerRow;

  return (
    <ResourceDetailItemContainer
      container
      spacing="1.5rem"
      columns={containerColumns}
    >
      {visibleItems.map((item, index) => (
        <Grid2
          key={`resource-detail-item-${index}`}
          size={getResourceDetailItemSize(containerColumns, item.colSpan)}
        >
          <ResourceDetailItem {...item} />
        </Grid2>
      ))}
    </ResourceDetailItemContainer>
  );
};
